import React, { Fragment, useState, useEffect } from 'react';
import NavbarS2 from '../../components/NavbarS2/NavbarS2'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import BlogSingle from '../../components/BlogDetails/BlogSingle'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg';

const BlogDetails = (props) => {
    const { slug } = useParams()
    const [blogDetails, setBlogDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const res = await fetch('/api/blogs');
                const data = await res.json();
                const blog = Array.isArray(data) ? data.find(b => b.slug === slug) : null;
                setBlogDetails(blog);
            } catch (error) {
                console.error('Error fetching blog:', error);
                setBlogDetails(null);
            } finally {
                setLoading(false);
            }
        };
        fetchBlog();
    }, [slug]);

    if (loading) {
        return (
            <Fragment>
                <NavbarS2 Logo={Logo} hclass={'wpo-site-header'} />
                <PageTitle pageTitle="Loading..." pagesub={'Blog'} />
                <section className="blog-single-section section-padding">
                    <div className="container">
                        <div style={{ textAlign: 'center', padding: '60px' }}>Loading blog post...</div>
                    </div>
                </section>
                <Footer />
                <Scrollbar />
            </Fragment>
        );
    }

    if (!blogDetails) {
        return (
            <Fragment>
                <NavbarS2 Logo={Logo} hclass={'wpo-site-header'} />
                <PageTitle pageTitle="Blog Not Found" pagesub={'Blog'} />
                <section className="blog-single-section section-padding">
                    <div className="container">
                        <div style={{ textAlign: 'center', padding: '60px' }}>Blog post not found.</div>
                    </div>
                </section>
                <Footer />
                <Scrollbar />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <NavbarS2 Logo={Logo} hclass={'wpo-site-header'} />
            <PageTitle pageTitle={blogDetails.title} pagesub={'Blog'} />
            <BlogSingle blogData={blogDetails} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogDetails;
